import { render, staticRenderFns } from "./upload-cover.vue?vue&type=template&id=7ce871fb&scoped=true"
import script from "./upload-cover.vue?vue&type=script&lang=js"
export * from "./upload-cover.vue?vue&type=script&lang=js"
import style0 from "./upload-cover.vue?vue&type=style&index=0&id=7ce871fb&prod&lang=css"
import style1 from "./upload-cover.vue?vue&type=style&index=1&id=7ce871fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce871fb",
  null
  
)

export default component.exports